import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const StyledAdditionalFields = styled(AdditionalFields)`
  margin: 0 0 35px;
`;
const FormAdvancedOptions = ({ onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { mimecastThrottleEnabled, mimecastStoreFullMessage } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(
    StyledAdditionalFields,
    {
      title: t("common.fields.advanced_options"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "mimecastThrottleEnabled",
        type: "checkbox",
        value: "enable-throttling",
        defaultChecked: mimecastThrottleEnabled == null ? void 0 : mimecastThrottleEnabled.value,
        onChange,
        label: t("common.fields.enable_throttling"),
        help: t("mimecastv2.advanced.throttling_help")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "mimecastStoreFullMessage",
        type: "checkbox",
        value: "enable-storeFullMessage",
        defaultChecked: mimecastStoreFullMessage == null ? void 0 : mimecastStoreFullMessage.value,
        onChange,
        label: t("common.fields.store_full_message"),
        help: t("mimecastv2.advanced.store_full_message_help")
      }
    )
  );
};
export default FormAdvancedOptions;
